import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/tasksActions'
import 'react-table/react-table.css'
import moment from 'moment'
import AddEditForm from '../../components/tasks/AddEditForm'
import { message, Tooltip } from 'antd'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import config from '../../config'

const propTypes = {}
const { API_BASE } = config

class Tasks extends Component {
  componentWillMount() {
    this.props.tasksRefresh()

    this.setState({
      modalVisible: false,
      currentId: null,
      currentTask: null,
      filtered: []
    })
  }

  handleToggleAddEditForm = () => {
    if (this.state.modalVisible) {
      this.setState({
        currentId: null,
        currentTask: null
      })
    }
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  handleAddTask = values => {
    values.created_date = moment().format('YYYY-MM-DD HH:mm:ss')
    values.updated_date = moment().format('YYYY-MM-DD HH:mm:ss')
    this.props.createTask({
      content: values,
      userId: this.props.authentication.user.userId
    })

    this.handleToggleAddEditForm()
    message.success('Task created')
  }

  handleEditTask = values => {
    values.updated_date = moment().format('YYYY-MM-DD HH:mm:ss')
    values.updated_by_id = this.props.authentication.user.userId
    this.props.editTask({
      content: values,
      taskId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentTask: null
    })

    this.handleToggleAddEditForm()
    message.success('Task edited')
  }

  handleDeleteTask = () => {
    this.props.deleteTask({
      taskId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentTask: null
    })

    this.handleToggleAddEditForm()
    message.success('Task deleted')
  }

  handleRowClick = row => {
    this.setState({
      currentId: row.id,
      currentTask: row
    })

    this.handleToggleAddEditForm()
  }

  handlePrintAll = () => {
    let queryString = ''
    this.state.filtered.map((filter, index) => {
      const separator = index === 0 ? '?' : '&'
      queryString += `${separator}${filter.id}=${filter.value}`
      return queryString
    })

    window.open(`${API_BASE}/api/tasks/printall${queryString}`, '_blank')
  }

  render() {
    const { payload } = this.props.tasksActions
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <AddEditForm
            currentId={this.state.currentId}
            userId={this.props.authentication.user.userId}
            modalVisible={this.state.modalVisible}
            handleToggleAddEditForm={this.handleToggleAddEditForm}
            handleAddTask={this.handleAddTask}
            handleEditTask={this.handleEditTask}
            handleDeleteTask={this.handleDeleteTask}
            currentTask={this.state.currentTask}
          />
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/tasks">Tasks</Link>
                </li>
              </ol>
            </nav>
            <h2>Tasks</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Tasks
                <div style={{ display: 'flex' }}>
                  <div className="jobsBarAdd" onClick={() => this.handlePrintAll()}>
                    <i className="fa fa-plus-square" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">PRINT ALL</div>
                  </div>
                  <div className="jobsBarAdd" onClick={this.handleToggleAddEditForm}>
                    <i className="fa fa-plus-square" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">NEW TASK</div>
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                filterable
                filtered={this.state.filtered}
                onFilteredChange={filtered => {
                  this.setState({ filtered })
                }}
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'name',
                        accessor: 'name',
                        minWidth: 200,
                        Cell: d => {
                          return <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                        }
                      },
                      {
                        Header: 'Type',
                        id: 'type',
                        accessor: 'type',
                        Cell: d => {
                          return <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                        }
                      },
                      {
                        Header: 'Description',
                        id: 'description',
                        accessor: 'description',
                        Cell: d => (
                          <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                        )
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        minWidth: 60,
                        Cell: d => {
                          const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Updated Date',
                        id: 'updated_date',
                        accessor: 'updated_date',
                        minWidth: 60,
                        Cell: d => {
                          const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ tasksActions, authentication }, ownProps) => ({
  tasksActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

Tasks.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Tasks))



// WEBPACK FOOTER //
// ./src/containers/tasks/index.js